import { render, staticRenderFns } from "./ProjetosGovernador.vue?vue&type=template&id=665d48a6&scoped=true"
import script from "./ProjetosGovernador.vue?vue&type=script&lang=js"
export * from "./ProjetosGovernador.vue?vue&type=script&lang=js"
import style0 from "./ProjetosGovernador.vue?vue&type=style&index=0&id=665d48a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d48a6",
  null
  
)

export default component.exports